import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getAllDocumentationAsync } from '@application/features/documentation/documentationThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import VnButton from '@ui/components/VnButton';
import VnDocumentTitle from '@ui/components/VnDocumentTitle';
import VnGridHeader from '@ui/components/VnGrid/VnGridHeader';
import VnPagination from '@ui/components/VnPagination';
import { addOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DocumentationTable from './DocumentationTable';
const Documentation = () => {
    VnDocumentTitle('Visser Documentatie');
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { documentations } = useAppSelector((state) => state.documentation);
    const handleAddDocumentationClick = () => {
        navigate(`/admin/DocumentationTabs`);
    };
    useEffect(() => {
        dispatch(getAllDocumentationAsync(documentationFilterValues));
    }, []);
    // -------------------------------  grid
    const defaultSortingCriteria = {
        sortColumnKey: 'created',
        sortDirection: 'desc'
    };
    const defaultDocumentationFilterValues = {
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        name: null,
        data: null,
        created: null,
        modified: null,
        modifiedBy: null
    };
    const [documentationFilterValues, setDocumentationFilterValues] = useState(defaultDocumentationFilterValues);
    const onRowClick = (rowId) => {
        window.open(`/admin/DocumentationTabs/${rowId}`, '_blank');
    };
    const updateDocumentationFilterValues = (newValues) => {
        setDocumentationFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    function searchDocumentationHandler(searchText) {
        updateDocumentationFilterValues({ filter: searchText });
        dispatch(getAllDocumentationAsync({
            ...documentationFilterValues,
            filter: searchText,
            pageNumber: 1
        }));
    }
    function DocumentationSortingHandler(data) {
        updateDocumentationFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
        dispatch(getAllDocumentationAsync({
            ...documentationFilterValues,
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        }));
    }
    function onDocumentationPageChange(pageNumber) {
        updateDocumentationFilterValues({ pageNumber });
        dispatch(getAllDocumentationAsync({
            ...documentationFilterValues,
            pageNumber
        }));
    }
    function DocumentationFilteringHandler(data) {
        data.pageNumber = 1;
        updateDocumentationFilterValues(data);
        dispatch(getAllDocumentationAsync({
            ...documentationFilterValues,
            ...data
        }));
    }
    // end grid
    return (_jsxs(_Fragment, { children: [_jsxs("div", { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginRight: 'auto',
                    marginLeft: '0rem',
                    marginTop: '2rem',
                    marginBottom: '2rem'
                }, children: [_jsx("h4", { children: "Documentatie" }), _jsx("div", { children: _jsx(VnButton, { icon: addOutline, customClassName: 'Vn-save-button', mode: 'primary', size: 'lg', text: 'Nieuwe Documentatie', onClick: handleAddDocumentationClick }) })] }), _jsx("div", { className: 'mt-0', children: _jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: true, onSearch: searchDocumentationHandler }), _jsx(DocumentationTable, { documentations: documentations?.items, onRowClick: onRowClick, onSorting: DocumentationSortingHandler, onFilter: DocumentationFilteringHandler, defaultSortingCriteria: defaultSortingCriteria }), _jsx("div", { className: 'mt-3', children: documentations && (_jsx(VnPagination, { currentPage: documentations?.pageNumber, totalPages: documentations?.totalPages, onPageChange: onDocumentationPageChange })) })] }) })] }));
};
export default Documentation;
